const EyeIcon = ({ color = "#20293C", size = "18" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 33 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.34176 11.052C5.54339 5.47558 10.5783 2 16.1297 2C21.6811 2 26.716 5.47553 29.9176 11.0519C30.3733 11.8456 30.3733 12.821 29.9176 13.6147C26.716 19.1911 21.681 22.6667 16.1297 22.6667C10.5783 22.6667 5.5434 19.1912 2.34177 13.6148C1.88608 12.8211 1.88608 11.8457 2.34176 11.052ZM16.1297 0C9.67907 0 4.06399 4.03551 0.607305 10.0562C-0.20244 11.4666 -0.202434 13.2003 0.607318 14.6107C4.06401 20.6313 9.67906 24.6667 16.1297 24.6667C22.5803 24.6667 28.1954 20.6312 31.6521 14.6105C32.4618 13.2002 32.4618 11.4664 31.652 10.0561C28.1953 4.03545 22.5803 0 16.1297 0ZM12.8799 12.3334C12.8799 10.5384 14.335 9.08337 16.1299 9.08337C17.9248 9.08337 19.3799 10.5384 19.3799 12.3334C19.3799 14.1283 17.9248 15.5834 16.1299 15.5834C14.335 15.5834 12.8799 14.1283 12.8799 12.3334ZM16.1299 7.08337C13.2304 7.08337 10.8799 9.43388 10.8799 12.3334C10.8799 15.2329 13.2304 17.5834 16.1299 17.5834C19.0294 17.5834 21.3799 15.2329 21.3799 12.3334C21.3799 9.43388 19.0294 7.08337 16.1299 7.08337Z"
      fill={color}
    />
  </svg>
);
export default EyeIcon;
